export const portfolioData = [
  {
    id: 1,
    site: 'https://mjs-cosmic-chariots.herokuapp.com/',
    repo: 'https://github.com/mjshelton12/cosmic_chariots_frontend',
    title: "Space Frontiers: Cosmic Chariots",
    tech: "MERN: MongoDB, Express, ReactJS, Node, GraphQL",
    img: 'https://camo.githubusercontent.com/8c54335e96f53c842314236152673262730a11629cbd9a1b6ed466e9d105a7ea/68747470733a2f2f692e696d6775722e636f6d2f325567574d76682e6a7067',
    description:
      "Imagine taking a vacation to space. Cosmic Chariots is a website that allow you to book a room and experience on a space cruise ship. Save your reservation and profile information.",
  },
  {
    id: 2,
    site: 'https://drive.google.com/file/d/121WzaiFfR9jA4MGwfDxZtyCp0SfEWysn/view',
    repo: 'https://github.com/mjshelton12/The_Social_API',
    title: "The Social API",
    tech: "MongoDB, Mongoose, Express, Postman",
    img: "https://camo.githubusercontent.com/8274f836ace6e19818d62b94f443ca80b81c2eb643ad5c5d77b8f405e51f8478/68747470733a2f2f692e696d6775722e636f6d2f636f33756349492e6a706567",
    description:
      "An API for a social media website. Includes the ability to create users, have users create thoughts (posts), and users to comment on each other's thoughts.",
  },
  {
    id: 3,
    site: 'https://mjs-escape-app.herokuapp.com/',
    repo: 'https://github.com/mjshelton12/MJs-Escape-App',
    title: "Escape App",
    tech: "Express, MySQL, Handlebars.js",
    img: 'https://github.com/Eat-The-Bagel/Escape-App/raw/main/assets/landing.png',
    description:
      "Escape App is a text style game that is played within a browser page. The user navigates around a home using button prompts to find what item(s) they need to escape.",
  },
  {
    id: 4,
    site: 'https://drive.google.com/file/d/1ExZbFwiT9v6-POdGpFcjqWGcohxg00pm/view?usp=sharing',
    repo: 'https://github.com/mjshelton12/Rosterize_Employee_Tracker',
    title: "Rosterize; Employee Tracker",
    tech: "Node.js, MySQL, Inquier",
    img: "https://camo.githubusercontent.com/6939a2ef470420299145e3f29bb44476795059aa25e87cb9c8f3416fcd5ad75c/68747470733a2f2f692e696d6775722e636f6d2f5a32754f537a482e6a7067",
    description:
      "Rosterize is an employee tracker that allows companies to keep track of employees, their positions, their salaries, their managers, and their departments. Employers can make use of get, post, put, and delete routes to track staff.",
  },
  {
    id: 3,
    site: "https://nwbootcamp.github.io/ShakenorStirred_Cocktails/",
    repo: "https://github.com/NWbootcamp/ShakenorStirred_Cocktails",
    title: "Shaken or Stirred Coctail App",
    tech: "Cocktail API, TimeZone DB API, Pexels Photo API, JavaScript",
    img: "https://github.com/NWbootcamp/ShakenorStirred_Cocktails/raw/main/assets/images/landingSC.png",
    description:
      "An app that takes in a user's age and preferences then suggests a cocktail for them to make that evening. Makes use of multiple API calls in order to get a drink to the user's specificities and then returns a recipe card.",
  },
  {
    id: 5,
    site: "https://mjshelton12.github.io/javascript_quiz/",
    repo: "https://github.com/mjshelton12/javascript_quiz",
    title: "JavaScript Quiz",
    tech: "JavaScript, HTML, CSS",
    img: "https://camo.githubusercontent.com/0f0f2d2476201ecdaf16332736949d8bf22328afe0f688c107e4265c87947490/68747470733a2f2f696d6775722e636f6d2f576a655a5169612e6a7067",
    description:
      "A one-page quiz with all elements appended using JS based on what the users clicks. The app sends a user through a timed quiz, saving their score and adding them to the high score list if they have a high enough score.",
  },
];

// {
//   id: 6,
//   site: "https://mjshelton12.github.io/Do-I-Need-a-Coat-Weather-App/",
//   repo: "https://github.com/mjshelton12/Do-I-Need-a-Coat-Weather-App",
//   title: "Do I Need a Coat?",
//   tech: "Weather API, JavaScript, HTML, CSS",
//   img: "https://camo.githubusercontent.com/b0868d20c06806bada3705167611ff162da02931502aff77bcfb8c23da37e569/68747470733a2f2f692e696d6775722e636f6d2f56546f4c4579502e6a7067",
//   description:
//     "A weather app that shows the current temperature, wind speed, and humidity and the 5 day forecast. Saves recently searched cities and lets you know if you need a coat.",
// },
